import { FC } from 'react';
import {
  Control,
  FormState,
  UseFormGetValues,
  UseFormRegister,
} from 'react-hook-form';

import type { Condition } from 'types/notification';
import { NotificationFormFields } from 'page/NotificationPage/types/notificationFormField';
import { useCustomerStore, useEditStore } from 'page/NotificationPage/hooks';
import { InputModalView } from './InputModalView';

type Props = {
  control: Control<NotificationFormFields>;
  formState: FormState<NotificationFormFields>;
  register: UseFormRegister<NotificationFormFields>;
  getValues: UseFormGetValues<NotificationFormFields>;
  handleClose: () => void;
  handleClickGoDelete: () => void;
  handleClickGoConfirmation: () => void;
};

export const InputModal: FC<Props> = ({
  control,
  formState,
  register,
  getValues,
  handleClose,
  handleClickGoDelete,
  handleClickGoConfirmation,
}) => {
  const { isOpenInputModal, shouldShowCustomerList, setCondition } =
    useEditStore();

  const { selectedCustomersLength } = useCustomerStore();

  /**
   * 配信対象顧客のラジオが変わったときの処理
   */
  const handleChangeCondition = (condition: Condition) => {
    setCondition(condition);
  };

  /** 確認ボタンの非活性状態 */
  const isButtonDisabled =
    !formState.isValid ||
    (shouldShowCustomerList && selectedCustomersLength === 0);

  return (
    <>
      {/* 入力モーダル */}
      <InputModalView
        control={control}
        formState={formState}
        isOpen={isOpenInputModal}
        shouldShowCostomerList={shouldShowCustomerList}
        isButtonDisabled={isButtonDisabled}
        register={register}
        getValues={getValues}
        handleClose={handleClose}
        handleChangeCondition={handleChangeCondition}
        handleClickGoDelete={handleClickGoDelete}
        handleClickGoConfirmation={handleClickGoConfirmation}
      />
    </>
  );
};
